import { writeTextOnCanvas } from './text';
import { createCanvas, createCanvasFromDataUrl, getCroppedCanvas, getScaledCanvas } from './canvas';
import { MAX_HEIGHT } from './constants';
export function isDataUrl(dataUrl) {
  return (dataUrl == null ? void 0 : dataUrl.startsWith('data:')) ?? false;
}
export function decodeDataUrl(dataUrl) {
  if (!dataUrl) {
    return undefined;
  }
  const arr = dataUrl.split(',');
  if (arr.length < 2) {
    return undefined;
  }
  const mimeArr = arr[0].match(/:([^;]*);?(.*)$/);
  if (!mimeArr || mimeArr.length < 2) {
    return undefined;
  }
  const encoding = mimeArr[2];
  return {
    encoding,
    type: mimeArr[1],
    value: encoding === 'base64' ? atob(arr[1]) : decodeURI(arr[1])
  };
}
export function encodeDataUrl(data, type, encoding) {
  if (encoding === void 0) {
    encoding = 'text';
  }
  const encodedData = encoding === 'base64' ? btoa(data) : encodeURI(data);
  const typeAndEncoding = encoding === 'base64' ? `${type};base64` : type;
  return `data:${typeAndEncoding},${encodedData}`;
}
export function dataUrlToFile(dataUrl, filename) {
  const decoded = decodeDataUrl(dataUrl);
  if (!decoded) {
    return undefined;
  }
  let n = decoded.value.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = decoded.value.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: decoded.type
  });
}
export function dataUrlToWixFile(url, displayName) {
  if (displayName === void 0) {
    displayName = 'temp';
  }
  const decoded = decodeDataUrl(url);
  return {
    fileId: 'temp',
    displayName,
    url,
    fileType: (decoded == null ? void 0 : decoded.type) ?? ''
  };
}
export async function dataUrlToPngDataUrl(dataUrl, backgroundColor) {
  const decodedDataUrl = decodeDataUrl(dataUrl);
  if (!decodedDataUrl) {
    return dataUrl;
  }
  if (decodedDataUrl.type === 'text/plain') {
    // Width doesn't matter, it will be cropped later
    const canvas = createCanvas(MAX_HEIGHT * 20, MAX_HEIGHT);
    writeTextOnCanvas(canvas, decodedDataUrl.value);
    const croppedCanvas = getCroppedCanvas(canvas, backgroundColor);
    // When cropped canvas is null it means we have an empty image ( example a transparent background )
    return (croppedCanvas == null ? void 0 : croppedCanvas.toDataURL('image/png')) ?? null;
  }
  if (decodedDataUrl.type.startsWith('image/')) {
    const canvas = await createCanvasFromDataUrl(dataUrl);
    const croppedCanvas = getCroppedCanvas(canvas, backgroundColor);
    if (!croppedCanvas) {
      // Empty image case
      return null;
    }
    const scaledCanvas = getScaledCanvas(croppedCanvas, undefined, MAX_HEIGHT);
    return scaledCanvas.toDataURL('image/png');
  }
  return dataUrl;
}
export async function processDataUrl(dataUrl, backgroundColor) {
  const pngDataUrl = await dataUrlToPngDataUrl(dataUrl, backgroundColor);
  if (!pngDataUrl) {
    return undefined;
  }
  return dataUrlToFile(pngDataUrl, 'signature.png');
}
//# sourceMappingURL=data-url.js.map